import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button, Dropdown, DropdownButton, Table, Alert, Spinner } from 'react-bootstrap';
import GenericSelectableList from './CustomSelectSearch'
import MultiColumnSelectableList from './MultiColumnSelectableList'
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import SessionService from '../../services/SessionsService';
import Cookies from 'universal-cookie';
import { useDropzone } from 'react-dropzone';
import { SketchPicker } from 'react-color';
import { useHistory } from 'react-router-dom';
import { FaPalette } from 'react-icons/fa';
import { ChromePicker } from 'react-color';

import img_layout1 from '../../assets/img/ui_icons/layout1.svg';
import img_layout2 from '../../assets/img/ui_icons/layout2.svg';

type ProcessFormProps = {
  isEditing: boolean;
  id?: string;
  products?: string[];
  basePath: string;
  projects: string[];
  name: string;
  description: string;
  normal_access: boolean;
  config: any;
  opened: any;
  environment: any;
  has_sandbox: any;
  endpoint: any;
  onSubmit: (proxy: {
    id?: string;
    name: string;
    description: string;
    open: boolean;
  }) => void;
};


const ProcessForm: React.FC<ProcessFormProps> = ({
  opened,
  isEditing,
  id,
  basePath = '',
  name = "",
  environment = {},
  has_sandbox = false,
  description = "",
  products = [],
  projects = [],
  normal_access = false,
  config,
  endpoint,
  onSubmit
}) => {
  const [localBasePath, setBasePath] = useState(basePath);
  const [localSelectedGA, setSelectedGA] = useState<any[]>(products);
  const [localRoutes, setRoutes] = useState<string[]>(projects);
  const [nameDp, setNameDp] = useState(name);
  const [nameDs, setNameDs] = useState(description);
  const [nameEs, setNameEs] = useState(endpoint);
  const [visibility, setVisibility] = useState('Standard');
  const [ogVisibility, setOgVisibility] = useState('');

  const [normalAccess, setNormalAccess] = useState(normal_access);
  const [fileLogo, setFileLogo] = useState();
  const [permissions, setPermissions] = useState([]);
  const [localSelectedCA, setSelectedCA] = useState([]);
  const [localSelectedA, setSelectedA] = useState(environment);
  const [GAS, setGas] = useState([]);
  const [loading, setLoading] = useState(false);

  const [apiProducts, setApiProducts] = useState([]);
  const [availableProjects, setAvailableProjects] = useState([]);

  const [isUsed, setisUsed] = useState(false);


  const [selectedProject, setSelectedProject] = useState('');
  const [selectedProjectID, setSelectedProjectID] = useState(0);
  const [selectedapiProduct, setselectedapiProduct] = useState('');
  const [selectedLayout, setSelectedLayout] = useState<number>(1);


  const [localConfig, setLocalConfig] = useState({})

  const history = useHistory();

  const handleChangeProject = async (project) => {
    console.log(project.target.value)


    setSelectedProjectID(project.target.value);

    availableProjects.forEach(gg => {

      if (gg.id == project.target.value)
        setSelectedProject(gg.descriptio);
    })

    await fetchAPIProducts(project.target.value);

  }

  const handleLayoutChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedLayout(Number(event.target.value));
  };

  const handleChangeApiProduct = (product) => {
    console.log(product.target.value);
    setselectedapiProduct(product.target.value);

  }


  

  const [AMBIENTS, setAMBIENTS] = useState([]);


  const fetchApiData = async () => {
    try {
      setLoading(true);
      const projectsResponse = await ObexRequestHandler.get('/projects', {}, true);
      setAvailableProjects(projectsResponse.data || []);
      console.log('Projects Response:', projectsResponse.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAPIProducts = async (project_id) => {


    const productsResponse = await ObexRequestHandler.get(`/publishing/get_products_by_org_live?org_id=${SessionService.ORGANIZATION}`, {}, true);

    const productsResponse2 = await ObexRequestHandler.get(`/publishing/get_products_by_org?org_id=${SessionService.ORGANIZATION}`, {}, true);

    const project_products = [];
    const project_products2 = [];

    productsResponse2.data.forEach(element => {
      if (element.project_id == project_id) {
        if (element.is_published_active == true) project_products2.push(element)
      }
    });



    productsResponse.data.forEach(element => {
      if (element.obex_project_id == project_id) {
        element.api_product_id = element.id;
        element.api_product_name = element.name;
        project_products.push(element)
      }
    });
    setApiProducts(project_products2 || []);
  }

  const getGAs = async () => {

    const gas = await ObexRequestHandler.get(`/gateway/get_gas?organization=${SessionService.ORGANIZATION}`);

    setGas(gas.data);

  }

  const [sandbox, setSandbox] = useState(false);

  const getAMBIENTS = async () => {
    const gas = await ObexRequestHandler.get(`/gateway/get_gateway_ambients?organization=${SessionService.ORGANIZATION}`);
    setAMBIENTS(gas.data);
  }

  const getCerts = async () => {
    const certs = await ObexRequestHandler.get(`/cert/get_certs?organization=${SessionService.ORGANIZATION}`)


    console.log(certs.data);

    console.log(certs.data.map((ga) => ({ id: ga.id, name: ga.name, region_id: ga.region_id })))
  };

  useEffect(()=>{

    if (!isEditing){
    setNameDp('');
    setNameDs('');
    setNameEs('');
    setBasePath('');
    setSelectedGA([]);
    setColor('#000000');
    setColor1('#1B8AE8');
    setColor2('#ffffff');
    setColor3('#f0f0f0');
    setVisibility('Standard');
    setSelectedLayout(1);
    setSelectedA(undefined)
    setSandbox(false)
    setShowPicker(false);
    setShowPicker1(false);
    setShowPicker2(false);
    setShowPicker3(false);
    setFileLogo(undefined);
    setLogoPreview(undefined)

    } else {
    setNameDp(name);
    setNameDs(description);
    setNameEs(endpoint);

    }
    // console.log('[PORTAL] valddate', !(localBasePath != basePath ||
    //   (localSelectedA && localSelectedA.id != config.environment_id?.id) ||
    //   nameDp !=name ||
    //   nameDs != description || ogVisibility != visibility ||
    //   config.layout != selectedLayout ||
    //  config.textColor != color
    //  || config.primaryColor != color1
    //  || config.secondaryColor != color2
    //  || config.backgroundColor != color3
    //  || fileLogo != null
    // ))
  

    history.push('/process');

  }, [opened])

  useEffect(() => {
    fetchApiData();
    setNameDp(name);
    setNameDs(description);
    setNameEs(endpoint);
    setBasePath(basePath);
    setSelectedGA(products);
    setColor(config.textColor);
    setColor1(config.primaryColor);
    setColor2(config.secondaryColor);
    setColor3(config.backgroundColor);
    setSelectedA(config.environment_id)
    setLogoPreview(config.logo)
    
    if (normal_access === true) {
      setVisibility('Standard');
      setOgVisibility('Standard');
    } else if (!normal_access && !config.visibility) {
      setVisibility('Private');
      setOgVisibility('Private');
    } else if (!normal_access && config.visibility) {
      setVisibility('Public');
      setOgVisibility('Public');
    }
    
    setSelectedLayout(config.layout);
    getCerts();
    getGAs();
    getAMBIENTS();
  }, [basePath, normal_access, config.visibility]);


  const handleAddGA = (ga: string) => {
    if (!localSelectedGA.includes(ga)) {
      setSelectedGA([...localSelectedGA, ga]);
    }
  };

  const handleRemoveGA = (ga: string) => {
    setSelectedGA(localSelectedGA.filter((item) => item !== ga));
  };

  const handleAddRoute = () => {
    setRoutes([...localRoutes, '']);
  };

  const handleUpdateRoute = (index: number, value: string) => {
    const updatedRoutes = [...localRoutes];
    updatedRoutes[index] = value;
    setRoutes(updatedRoutes);
  };

  const handleRemoveRoute = (index: number) => {
    setRoutes(localRoutes.filter((_, i) => i !== index));
  };

  const handleCopyCert = (cert: string) => {
    navigator.clipboard.writeText(cert).then(() => {
      alert('Certificate copied to clipboard!');
    });
  };


  const handleAddCA = (permit) => {
    // Añade un permiso seleccionado
    if (!localSelectedCA.some((p) => p.id === permit.id)) {
      setSelectedCA((prev) => [...prev, permit]);
    }
  };

  const handleRemoveCA = (permit) => {
    // Elimina un permiso seleccionado
    setSelectedCA((prev) => prev.filter((p) => p.id !== permit.id));
  };


  const handleAddA = (permit) => {
    // Añade un permiso seleccionado
    /*
    if (!localSelectedA.some((p) => p.id === permit.id)) {
      setSelectedA((prev) => [...prev, permit]);
    }*/
      setSelectedA(permit)
  };

  const handleRemoveA = (permit) => {
    // Elimina un permiso seleccionado
   // setSelectedA((prev) => prev.filter((p) => p.id !== permit.id));
  };

  const readFileAsBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(new Error("Error reading file"));
      reader.readAsDataURL(file); // Convierte el archivo a base64
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

      const cookies = new Cookies();
      const userInfo = cookies.get('101Obex');
      const payload = {}

      try {


        
        if (!isEditing) {


          //let kl = await ObexRequestHandler.get(`/gateway/check_devportal?devportal_route=${localBasePath}`)

          if (/*kl.data.isUsed*/ false ) {
            setisUsed(true);
            return; // Salir si ya está en uso
          }

          await ObexRequestHandler.post(`/create_process?obex_project_id=${projects[0]}&name=${nameDp}&description=${nameDs}&endpoint=${nameEs}`, payload);
        } else {
          await ObexRequestHandler.post(`/update_process?obex_project_id=${projects[0]}&name=${nameDp}&description=${nameDs}&endpoint=${nameEs}`);
        }


        // Si llegamos aquí, la operación fue exitosa
        onSubmit({
          id,
          name: nameDp,
          description: nameDs,
          open:isEditing
        });

        // Redirigir después de un guardado exitoso
        history.push('/process');
      } catch (error) {
        console.error('Error al guardar:', error);
      
      }
   // }
  };


  ////////


  const [selectedColors, setSelectedColors] = useState({
    primary: '#000000', // Color primario por defecto
    secondary: '#ffffff', // Color secundario por defecto
    background: '#f0f0f0', // Color de fondo por defecto
    text: '#333333' // Color de texto por defecto
  });

  const [logoPreview, setLogoPreview] = useState(null);

  const handleColorChange = (color, field) => {
    setSelectedColors((prevColors) => ({
      ...prevColors,
      [field]: color.hex
    }));
  };

  const handleLogoChange = (acceptedFiles) => {
    const file = acceptedFiles[0];
    setFileLogo(file);
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setLogoPreview(fileURL);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleLogoChange
  });


  ///////

  const [color, setColor] = useState(''); // Color inicial (puedes cambiar el valor)
  const [color1, setColor1] = useState(''); // Color inicial (puedes cambiar el valor)
  const [color2, setColor2] = useState(''); // Color inicial (puedes cambiar el valor)
  const [color3, setColor3] = useState(''); // Color inicial (puedes cambiar el valor)
  const [showPicker, setShowPicker] = useState(false); // Controla si el picker está visible
  const [showPicker1, setShowPicker1] = useState(false); // Controla si el picker está visible
  const [showPicker2, setShowPicker2] = useState(false); // Controla si el picker está visible
  const [showPicker3, setShowPicker3] = useState(false); // Controla si el picker está visible
  // Maneja el cambio de color del picker
  const handleChangeComplete = (color: { hex: string }) => {
    setColor(color.hex); // Actualiza el color al seleccionar uno del picker
  };

  const handleChangeComplete1 = (color1: { hex: string }) => {
    setColor1(color1.hex); // Actualiza el color al seleccionar uno del picker
  };

  const handleChangeComplete2 = (color2: { hex: string }) => {
    setColor2(color2.hex); // Actualiza el color al seleccionar uno del picker
  };

  const handleChangeComplete3 = (color3: { hex: string }) => {
    setColor3(color3.hex); // Actualiza el color al seleccionar uno del picker
  };

  // Manejador del botón para mostrar/ocultar el picker
  const togglePicker = () => {
    setShowPicker(!showPicker);

    setShowPicker1(false);
    setShowPicker2(false);
    setShowPicker3(false);

  };
  const togglePicker1 = () => {
    setShowPicker1(!showPicker1);

    setShowPicker(false);
    setShowPicker2(false);
    setShowPicker3(false);
  };

  const togglePicker2 = () => {
    setShowPicker2(!showPicker2);

    setShowPicker1(false);
    setShowPicker(false);
    setShowPicker3(false);
  };

  const togglePicker3 = () => {
    setShowPicker3(!showPicker3);

    setShowPicker1(false);
    setShowPicker2(false);
    setShowPicker(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      {/*
      <Form.Group controlId="basePath" className="mb-3">
        <Form.Label>Basepath</Form.Label>
        <Form.Control
        required
          type="text"
          placeholder="Enter basepath"
          value={localBasePath}
          onChange={(e) => {
            setisUsed(false);
            setBasePath(e.target.value)}}
        />
      </Form.Group>
    */}
      <Form.Group controlId="basePath" className="mb-3">
        <Form.Label>Name</Form.Label>
        <Form.Control
        required
          disabled = {isEditing}
          type="text"
          placeholder="Enter name"
          value={nameDp}
          onChange={(e) => setNameDp(e.target.value)}
        />
      </Form.Group>


      <Form.Group controlId="basePath" className="mb-3">
        <Form.Label>Description</Form.Label>
        <Form.Control
        required
          type="text"
          placeholder="Enter description"
          value={nameDs}
          onChange={(e) => setNameDs(e.target.value)}
        />
      </Form.Group>


      <Form.Group controlId="basePath" className="mb-3">
        <Form.Label>Endpoint</Form.Label>
        <Form.Control
        required
          type="text"
          placeholder="Enter endpoint"
          value={nameEs}
          onChange={(e) => setNameEs(e.target.value)}
        />
      </Form.Group>

    

      <Row>
        <Col md="12" style={{textAlign:'end'}} >
         {/*  Validaciones diferentes para activar el boton según si es de creación o de edición*/}

        {!isEditing && <Button className="w-100" 
          disabled={
         
              !nameDp ||
              !nameDs ||
              !nameEs
      
          }
          variant="primary" type="submit"
                          style={{
                    backgroundColor:'var(--color-btn-green)',
                    borderBlockColor:'var(--color-btn-green)',
                    borderStyle:'none',
                    paddingTop:'2px',
                    paddingBottom:'2px',
                    paddingLeft:'15px',
                    paddingRight:'15px',
                    fontSize:'15px',
                    maxWidth:'100px'
                    }}
          
          >
            Save
          </Button>}
          {isEditing && <Button className="w-100" 
          disabled={
            !(
              nameDp !=name ||
              nameDs != description ||
              nameEs != endpoint
            )
          }
          variant="primary" type="submit"
                          style={{
                    backgroundColor:'var(--color-btn-green)',
                    borderBlockColor:'var(--color-btn-green)',
                    borderStyle:'none',
                    paddingTop:'2px',
                    paddingBottom:'2px',
                    paddingLeft:'15px',
                    paddingRight:'15px',
                    fontSize:'15px',
                    maxWidth:'100px'
                    }}
          
          >
            Save
          </Button>}
        </Col>
      </Row>
    </Form>
  );
};



export default ProcessForm;
